<template src="./html/Reports.html"></template>

<script>
	import swal from 'sweetalert2'
	import Ladda from 'ladda'

	import Filter from './../views/Filter.vue'
	import Export from './../../export/Export.vue'

	export default {
		props: ['user', 'isAuth'],
		components: {
			'filter-component': Filter,
			'export-component': Export,
		},
		data () {
			return {
				downloading: false,

				data: {
					tasks: null,
					projects: null,
					tasks_users: null,
					tasks_customers: null,
					total_time: null,
					total: null,
				},

				dataFilter: {
					report_type: 'tasks',
					task_status_id: null,
					project_status_id: null,
					export: null,
					date: null,
					customer_id: null,
					place_id: null,
					place_id: null,
					department_id: null,
					user_id: null,
				},

				dataExport: {
					url: 'admin/projects/reports/',
					show: true,
				},
			}
		},
		watch: {
			'departmentSelected': function(department) {
				if(department) {
					this.users = null
					this.dataFilter.user_id = null
					this.dataFilter.department_id = department.id
					this.users = department.users
				} else {
					this.dataFilter.user_id = null
					this.dataFilter.department_id = null
					this.users = null
				}
			},
		},
		methods: {
			reports: function() {
				var l = Ladda.create(document.querySelector('#btn-filter'))
				l.start()
				this.data.total = null
				this.data.tasks = null
				this.data.projects = null
				this.data.tasks_users = null
				this.data.tasks_customers = null

				var report_type = this.dataFilter.report_type
				this.dataFilter.date = $('#daterange').val()

				if(report_type == 'tasks') {
					var api = 'admin/projects/reports/tasks'
				} else if(report_type == 'projects') {
					var api = 'admin/projects/reports/projects'
				} else if(report_type == 'closing_users') {
					var api = 'admin/projects/reports/tasks/closing/users'
				} else if(report_type == 'closing_customers'){
					var api = 'admin/projects/reports/tasks/closing/customers'
				} else {
					var api = null
				}

				if(api) {
					this.dataExport.url = api
					var data = {
						filter: this.dataFilter,
					}
					this.$http.post(api, data)
						.then(response => {
							l.stop()
							if(response.body) {

								this.data.total = response.body['total_result']

								if(response.body['tasks']) {
									this.data.tasks = response.body['tasks']
								}

								if(response.body['projects']) {
									this.data.projects = response.body['projects']
								}

								if(response.body['tasks_users']) {
									this.data.tasks_users = response.body['tasks_users']
								}

								if(response.body['tasks_customers']) {
									this.data.tasks_customers = response.body['tasks_customers']
								}

								if(response.body['total_time']) {
									this.data.total_time = response.body['total_time']
								}

								if(response.body['total_closing_time']) {
									this.data.total_closing_time = response.body['total_closing_time']
								}

								if(response.body['total_time_spent']) {
									this.data.total_time_spent = response.body['total_time_spent']
								}
							} else {
								this.data.tasks = null
								this.data.tasks_customers = null
								this.data.tasks_users = null
							}
						}).catch(function(response) {
							console.log(response)
							l.stop()
						})
				}
			},
			clearData() {
				var year = moment().format('YY')
				var month = moment().format('MM')
				var startDate = moment([year, month - 1])
				var endDate = moment()
				$('#daterange').data('daterangepicker').setStartDate(startDate.format('DD/MM/YY'))
				$('#daterange').data('daterangepicker').setEndDate(endDate.format('DD/MM/YY'))

				this.dataFilter.report_type = 'tasks'
				this.dataFilter.task_status_id = null
				this.dataFilter.project_status_id = null
				this.dataFilter.export = null
				this.dataFilter.date = startDate.format('DD/MM/YY') + ' - ' + endDate.format('DD/MM/YY')
				this.dataFilter.customer_id = null
				this.dataFilter.place_id = null
				this.dataFilter.place_id = null
				this.dataFilter.department_id = null
				this.dataFilter.user_id = null
			},
			clear() {
				this.clearData()
				this.$refs.filterComponent.clearFilter()
			}
		}
	}
</script>


// WEBPACK FOOTER //
// src/components/projects/reports/layout/Reports.vue